import React, { useEffect, useState, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { NameSurname, Status } from "./contactlistCol";

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import axios from 'axios';

import "jspdf-autotable";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import {
  getLimit as onGetLimit,
  addLimit as onAddLimit,
  updateLimit as onUpdateLimit,
  deleteLimit as onDeleteLimit,
} from "store/contacts/actions";
import { isEmpty } from "lodash";
import Dropzone from 'react-dropzone-uploader';


//redux
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { Base64 } from 'js-base64';


const ContactsList = props => {
  const tableRef = useRef(null);

  document.title = "Koçlar | TriMentor ADMIN PANELI";
  
  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  const [contactEdit, setEditContact] = useState();
  const [getTeacherID, setTeacherID] = useState();
  const [getUser, setUser] = useState([]);
  const [getIsActive, setIsActive] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [currentTeacherStudents, setCurrentTeacherStudents] = useState([]);
  const [getHtmlDataLong, setHtmlDataLong] = useState();
  const [modal, setModal] = useState(false);
  const [modalUsers, setModalUser] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [getUserID, setUserID] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [imageFile, setImageFile] = useState('');

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      shortDesc: (contactEdit && contactEdit.Teacher_ShortDesc) || "",
      historyDesc: (contactEdit && contactEdit.Teacher_History) || "",
      teacherPrice: (contactEdit && contactEdit.Teacher_Price) || "",
      teacherPhone: (contactEdit && contactEdit.Customer_TelephoneNumber) || "",
      teacherExperience: (contactEdit && contactEdit.Teacher_Experience) || "",
    },
    validationSchema: Yup.object({}),
    onSubmit: values => {
      const payload = {
          Teacher_Url: imageFile,
          Teacher_ShortDesc: values.shortDesc,
          Teacher_History: values.historyDesc,
          IsActive: getIsActive,
          Customer_TelephoneNumber: values.teacherPhone,
          Teacher_Desc: Base64.encode(getHtmlDataLong || ''),
          Users_ID: getUserID
      };

      console.log("payload1231",payload)
      if (isEdit) {
        const updateUser = { ID: contactEdit.ID, ...payload };
        dispatch(onUpdateLimit(updateUser));
      } else {
        dispatch(onAddLimit(payload));
      }
      validation.resetForm();
      toggle();
    },
  });

  const { users } = useSelector(state => ({
    users: state.contacts.limit,
  }));
  
  const columns = useMemo(
    () => [
      { Header: "#", Cell: () => <input type="checkbox" className="form-check-input" /> },
      { Header: "ID", accessor: "Users.ID", Cell: NameSurname },
      {
        Header: "Foto",
        accessor: (cellProps) => (
          <>
            {cellProps.Teacher_Url ? (
              <img className="avatar-sm rounded-circle" src={'https://megasubdomain.stechomeyazilim.info/' + cellProps.Teacher_Url} alt="" />
            ) : (
              <div className="avatar-sm"><span className="avatar-title rounded-circle bg-light text-dark">F</span></div>
            )}
          </>
        ),
      },
      { Header: "Kullanıcı Adı", accessor: "Users.Users_NameSurname", Cell: NameSurname },
      { Header: "Telefon Numarası", accessor: "Users.Users_TelephoneNumber", Cell: NameSurname },
      {
        Header: "Öğrencileri",
        accessor: (cellProps) => (
          <>
            {cellProps.Teacher_OfUsers && cellProps.Teacher_OfUsers.length > 0 ? (
              cellProps.Teacher_OfUsers.map((item, index) => (
                <div key={item.ID}>
                  {item.Users && <span>{item.Users.ID} - {item.Users.Users_NameSurname}</span>}
                </div>
              ))
            ) : (
              <span>Öğrencisi Yok</span>
            )}
          </>
        ),
      },
      { Header: "Aktif Mi?", accessor: "IsActive", Cell: Status },
      {
        Header: "İşlemler",
        Cell: ({ row }) => (
          <div className="d-flex gap-3">
            <Link to="#" className="text-info" onClick={() => handleUserClickUser(row.original)}>
              <i className="mdi mdi-account-multiple-plus font-size-18" id={`addstudenttooltip-${row.id}`} />
              <UncontrolledTooltip placement="top" target={`addstudenttooltip-${row.id}`}>Öğrenci Ata</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-success" onClick={() => handleUserClick(row.original)}>
              <i className="mdi mdi-pencil font-size-18" id={`edittooltip-${row.id}`} />
              <UncontrolledTooltip placement="top" target={`edittooltip-${row.id}`}>Düzenle</UncontrolledTooltip>
            </Link>
            <Link to="#" className="text-danger" onClick={() => onClickDelete(row.original)}>
              <i className="mdi mdi-delete font-size-18" id={`deletetooltip-${row.id}`} />
              <UncontrolledTooltip placement="top" target={`deletetooltip-${row.id}`}>Sil</UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  const _addUsers = async () => {
    const localDate = moment().local();
    const addPromises = selectedUsers.map((item) => {
      const newUser2 = {
        Users_ID: item,
        Teacher_ID: getTeacherID,
        Created_DateTime: localDate,
      }
      return axios.post('https://trimentoradmin.stechomeyazilim.info:4436/addTeacherUsersEfso/send', newUser2);
    });

    try {
      await Promise.all(addPromises);
      toggleUsers();
      showToast(true, "Yeni öğrenciler başarıyla atandı.");
      setTimeout(() => dispatch(onGetLimit()), 500);
      validation.resetForm();
    } catch (error) {
      console.error("Öğrenci eklenirken hata oluştu:", error);
      showToast(false, "Öğrenciler eklenirken bir sorun oluştu.");
    }
  }

  function showToast(type, message) {
    let ele = type ? "success" : "error";
    if (!message) message = type ? "İşlem Başarılı" : "Bir hata oluştu!";
    toastr.options = { positionClass: "toast-top-right", timeOut: 5000, progressBar: true, closeButton: true };
    toastr[ele](message, ele.charAt(0).toUpperCase() + ele.slice(1));
  }
  
  // DÜZELTİLDİ: Öğrenci-Koç ilişkisini silen fonksiyon
  const handleDeleteStudent = async (relationshipId) => {
    if (!relationshipId) {
      showToast(false, "Silinecek öğrenci bilgisi eksik.");
      return;
    }
    try {
      console.log("şmsdşflds",relationshipId)
      // API'ye doğru ID ile silme isteği gönder
      await axios.delete(`https://trimentoradmin.stechomeyazilim.info:4436/deleteTeacherOfUsersEfso/${relationshipId}`);
      setCurrentTeacherStudents(prevStudents => prevStudents.filter(s => s.ID !== relationshipId));
      dispatch(onGetLimit());
      showToast(true, "Öğrenci, koçun listesinden başarıyla kaldırıldı.");
    } catch (error) {
      console.error("Öğrenci silinirken hata oluştu:", error);
      showToast(false, "Öğrenci kaldırılırken bir hata oluştu.");
    }
  };

  useEffect(() => {
    const _getAuthData2 = async () => {
      try {
        const res = await axios.get(`https://trimentoradmin.stechomeyazilim.info:4436/getUsersKullaniciEfso/select/`);
        console.log("res12312",res)
        setUser(res.data);
      } catch (e) {
        console.error("Kullanıcılar alınamadı", e);
      }
    };
    _getAuthData2();
    if (isEmpty(users)) {
      dispatch(onGetLimit());
    }
  }, [dispatch, users]);
  
  const toggle = () => setModal(!modal);
  const toggleUsers = () => setModalUser(!modalUsers);
  
  // BU SİZİN İSTEDİĞİNİZ DOĞRU YÖNTEM
  const handleUserClickUser = (data) => {
    setTeacherID(data.ID);
    // Koçun mevcut öğrencilerini (ilişki tablosu verisi olarak) state'e ata
    setCurrentTeacherStudents(data.Teacher_OfUsers || []);
    setSelectedUsers([]); // Yeni seçimler için listeyi temizle
    toggleUsers();
  };

  const handleUserClick = (arg) => {
    setEditContact(arg);
    setIsEdit(true);
    setUserID(arg.Users_ID);
    setIsActive(arg.IsActive);
    setImageFile(arg.Teacher_Url);
    if (arg.Teacher_Desc) {
      setHtmlDataLong(Base64.decode(arg.Teacher_Desc));
    }
    toggle();
  };
  
  const onClickDelete = (user) => {
    setContact(user);
    setDeleteModal(true);
  };
  const handleDeleteUser = () => {
    if (contact && contact.ID) {
      dispatch(onDeleteLimit(contact.ID));
    }
    setDeleteModal(false);
  };
  const handleUserClicks = () => {
    setIsEdit(false);
    toggle();
  };

    const getUploadParams = ({ file }) => {
    const body = new FormData();
    body.append('dataFile', file);
    return { url: 'https://megaadmin.stechomeyazilim.info:8080/uploadfile', body };
  };
  

  function showToast(title, message, isSuccess) {
    toastr.options = {
        positionClass: "toast-top-right",
        timeOut: 5000,
        progressBar: true,
        closeButton: true,
        newestOnTop: true
    };
    if (isSuccess) {
        toastr.success(message, title);
    } else {
        toastr.error(message, title);
    }
  }

const handleImageChangeStatus = ({ meta, xhr, remove }, status) => { // 'meta' parametresini ekleyin
    if (status === 'done') {
        const result = JSON.parse(xhr.response);
        setImageFile(result.file.filename);
        // <-- BURAYA EKLEYİN
        showToast("Yükleme Başarılı", `'${meta.name}' adlı resim dosyası yüklendi.`, true);
    }
    if (status === 'removed') {
        setImageFile('');
    }
  };

  return (
    <React.Fragment>
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteUser} onCloseClick={() => setDeleteModal(false)} />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Koçlar" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns} data={users} isGlobalFilter={true} isAddLimit={true}
                    handleOrderClicks={handleUserClicks} customPageSize={10} className="custom-header-css"
                  />
                  <Modal isOpen={modalUsers} toggle={toggleUsers}>
                    <ModalHeader toggle={toggleUsers} tag="h4">Öğrenci Ata</ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xs={12}>
                          <div className="mb-3">
                            <Label className="form-label">Yeni Öğrenci Seçiniz</Label>
                            <Input
                              name="group" type="select" className="form-select" multiple
                              value={selectedUsers}
                              onChange={(e) => setSelectedUsers(Array.from(e.target.selectedOptions, option => option.value))}
                            >
                              {getUser.filter(user =>
                             
                                // DÜZELTİLDİ: Öğrencinin `Users_ID`'si ile karşılaştır
                                !currentTeacherStudents.some(rel => rel.Users_ID === user.ID)
                              ).map((item) => (
                                <option value={item.ID} key={item.ID}>{item.Users_NameSurname}</option>
                              ))}
                            </Input>
                          </div>
                        </Col>
                      </Row>
                      {(currentTeacherStudents.length > 0) && (
                        <Row>
                          <Col xs={12}>
                            <hr />
                            <h5>Mevcut Öğrenciler</h5>
                            <div className="d-flex flex-wrap gap-2">
                              {currentTeacherStudents.map((relation) => (
                                <div key={relation.ID} className="btn btn-light d-flex align-items-center">
                                  {relation.Users?.Users_NameSurname}
                                  <button
                                    type="button" className="btn-close ms-2"
                                    onClick={() => handleDeleteStudent(relation.ID)} // İlişki ID'sini gönder
                                    aria-label="Kaldır"
                                  ></button>
                                </div>
                              ))}
                            </div>
                          </Col>
                        </Row>
                      )}
                      <Row className="mt-4">
                        <Col>
                          <div className="text-end">
                            <button
                              onClick={_addUsers} type="button" className="btn btn-success"
                              disabled={selectedUsers.length === 0}
                            >
                              Yeni Öğrencileri Kaydet
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </ModalBody>
                  </Modal>

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">{isEdit ? "Düzenle" : "Ekle"}</ModalHeader>
 <ModalBody>
  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
    <Row>
      {/* SADECE YENİ KOÇ EKLERKEN GÖRÜNECEK KULLANICI SEÇİMİ */}
      {!isEdit && (
        <Col xs={12}>
          <div className="mb-3">
            <Label className="form-label">Hangi Kullanıcı Koç Olacak?</Label>
            <Input
              name="Users_ID"
              type="select"
              className="form-select"
              onChange={(e) => setUserID(e.target.value)}
              value={getUserID || ""}
            >
              <option value="">Lütfen bir kullanıcı seçin...</option>
              {getUser
                .filter(user => !users.some(coach => coach.Users_ID === user.ID))
                .map(item => (
                  <option value={item.ID} key={item.ID}>{item.Users_NameSurname}</option>
                ))
              }
            </Input>
          </div>
        </Col>
      )}

      <Col md={6}>
        <div className="mb-3">
          <Label className="form-label">Kısa Açıklama</Label>
          <Input
            name="shortDesc"
            type="text"
            placeholder="Koç hakkında kısa bir açıklama"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.shortDesc}
          />
        </div>
      </Col>

      <Col md={6}>
        <div className="mb-3">
          <Label className="form-label">Geçmiş / Biyografi</Label>
          <Input
            name="historyDesc"
            type="text"
            placeholder="Koçun geçmişi ve biyografisi"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.historyDesc}
          />
        </div>
      </Col>


      <Col md={12}>
        <div className="mb-3">
          <Label className="form-label">Telefon Numarası</Label>
          <Input
            name="teacherPhone"
            type="tel"
            placeholder="Koçun telefon numarası"
            onChange={validation.handleChange}
            onBlur={validation.handleBlur}
            value={validation.values.teacherPhone}
          />
        </div>
      </Col>

      <Col xs={12}>
        <div className="mb-3">
          <Label className="form-label">Detaylı Açıklama</Label>
          <CKEditor
            editor={Editor}
            data={getHtmlDataLong}
            onChange={(event, editor) => {
              const data = editor.getData();
              setHtmlDataLong(data);
            }}
          />
        </div>
      </Col>

      {/* --- DÜZELTİLMİŞ FOTOĞRAF YÜKLEME ALANI --- */}
      <Col xs={12}>
          <div className="mb-3">
                                <Label>Görsel</Label>
                                {isEdit && imageFile && <div className="mb-2 text-muted">Mevcut Dosya: {imageFile}</div>}
                                <Dropzone
                                    getUploadParams={getUploadParams}
                                    onChangeStatus={handleImageChangeStatus}
                                    maxFiles={1}
                                    multiple={false}
                                    accept="image/*"
                                    inputContent="Resim dosyası sürükleyin veya seçin"
                                />
                            </div>
      </Col>
      
      <Col xs={12}>
       <div className="square-switch">

                            <input
                              type="checkbox"
                              id="square-switch1"
                              className="switch"
                              defaultChecked={getIsActive}
                              onChange={() =>
                                setIsActive(!getIsActive)
                              }
                            />
                            <label
                         htmlFor="square-switch1"
                              data-on-label="Aktif "
                              data-off-label="Pasif"
                            />
                          </div>
      </Col>
    </Row>
    <Row>
      <Col>
        <div className="text-end mt-4">
          <button type="submit" className="btn btn-success save-user">Kaydet</button>
        </div>
      </Col>
    </Row>
  </Form>
</ModalBody>

                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);